import './resource-show-preview.css';
